export default "/images/layout-three-columns.svg?6ef3f51224f64d0d7dbb2c052af99c56";